"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackDifferentDeliveryAddressSelected = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
function trackDifferentDeliveryAddressSelected(clickText) {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: enums_1.EventAction.BoxClick,
        eventLabel: 'Different delivery address',
        eventData: {
            eventName: enums_1.GA4EventName.SelectCheckBox,
            feature_category: enums_1.GA4FeatureCategory.Cart,
            click_element: 'change delivery adress',
            click_text: clickText,
        },
    });
}
exports.trackDifferentDeliveryAddressSelected = trackDifferentDeliveryAddressSelected;
//# sourceMappingURL=trackDifferentDeliveryAddressSelected.js.map